import { render } from "./paradigm.vue?vue&type=template&id=8881ff0c"
import script from "./paradigm.vue?vue&type=script&lang=js"
export * from "./paradigm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__